// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDaH8OmXwWOXIcKzpvvppoG_qkT3VEE5Yo",
  authDomain: "portfolio-production-2020.firebaseapp.com",
  databaseURL: "https://portfolio-production-2020.firebaseio.com",
  projectId: "portfolio-production-2020",
  storageBucket: "portfolio-production-2020.appspot.com",
  messagingSenderId: "976880368012",
  appId: "1:976880368012:web:134e0ec47cf0f3a0237ea9",
  measurementId: "G-PZPC30NBYB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);

export {app};
